// extracted by mini-css-extract-plugin
module.exports = {"flex":"flex_flex__6jDPQ"};